module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_iwate-736a2ba052b88c6c425a621e5ae280ae.png";